import clsx from 'clsx';
import { type ReactNode, useState } from 'react';

interface Props {
    short?: ReactNode | string;
    long?: ReactNode | string;
    shortClassName?: string;
}

// TODO:
//   - use Tooltip from flowbite-react
//   - Make sure it looks good on light and dark mode
export function Explanation({ short, long, shortClassName }: Props) {
    const [ showTooltip, setShowTooltip ] = useState(false);
    return (
        <div className={clsx('text-xs text-gray-400 mt-1 relative inline-block', shortClassName)}>
            <span>{short}</span>
            {long
                ? (
                    <span
                        className='ml-1 text-blue-400 cursor-pointer'
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                        onClick={() => setShowTooltip(!showTooltip)}
                    >
                        ?
                    </span>
                )
                : null}
            {showTooltip && (
                <div className='absolute z-10 bg-gray-700 text-white text-xs p-2 rounded shadow-lg mt-1 max-w-xs border-1 border-white'>
                    {long}
                </div>
            )}
        </div>
    );
}
